var DocumentsUtils = new function() {
  this.documentVersionFormatter = function(row, cell, documentVersion, columnDef, dataContext) {
    var text;

    if (documentVersion.hasOwnProperty("submittedDocuments")) {
      var listItems = _.inject(
        documentVersion.submittedDocuments,
        function (text, doc) {
          var item = "<li><a href='" + doc.url +"'>" + doc.title + "</a></li>";
          return text + item;
        },
        ""
      );
      text = (listItems == "") ? "none" : "<ul>" + listItems + "</ul>";
    } else if (documentVersion.hasOwnProperty("version")) {
      if (documentVersion.hasOwnProperty("boq")) {
        text = "Received v." + documentVersion.version;
      } else {
        text = "Accepted v." + documentVersion.version;
      }
      if (documentVersion.hasOwnProperty("url") ) {
        text = "<a href='" + documentVersion.url + "'>" + text + "</a>";
      }
      if (documentVersion.hasOwnProperty("download") ) {
        text = "<a id='download_document_col' href='" + documentVersion.url + "'>Download</a>";
      }
    } else {
      text = "N/A";
    }
    return text;
  };
  this.loadColumns = function(documentData, visibleBidders) {
    var documentsColumns = [
      { id: "documentname", name: "Document Name", field: "name", width: 150 }
    ];

    _.each(visibleBidders, function(bidderName, key) {
      var bidderColumn = _.select(documentData.columns, function(c){ return bidderName == c.name; })[0];
      if (bidderColumn) {
        documentsColumns.push({
          id: bidderColumn.field,
          name: bidderColumn.name,
          field: bidderColumn.field,
          width: 150,
          formatter: DocumentsUtils.documentVersionFormatter
        });
      }
    });

    return documentsColumns;
  };
};
